<div class="mt-4" *ngIf="dataChart && dataChartColumns">
  <!-- misurazione fatturato costi -->
  <div class="card card-chart">
    <div class="row mx-0">
      <div class="col-md-12 col-12 revenue-report-wrapper">
        <div id="revenue-report-chart">
          <apx-chart
            [series]="dataChart?.series"
            [chart]="chartOptions?.chart"
            [xaxis]="dataChart?.xaxis"
            [stroke]="chartOptions?.stroke"
            [yaxis]="chartOptions?.yaxis"
            [dataLabels]="chartOptions?.dataLabels"
            [tooltip]="chartOptions?.tooltip"
            [legend]="chartOptions?.legend"
          ></apx-chart>
        </div>
      </div>
    </div>
  </div>
</div>
